export const ApiHeader = {
  ETag: 'ETag',
  IfModifiedSince: 'If-Modified-Since',
  IfNoneMatch: 'If-None-Match',
  LastModified: 'Last-Modified',
  OrganizationId: 'x-organization-id',
} as const;

export const HttpObserve = {
  Response: 'response',
} as const;

/** TODO Rename to `ApiEndpointFragment` and split into smaller re-usable parts */
export const ApiEndpoint = {
  AdminPanelFinanceCredentialProfiles: 'admin-panel/finance-credential-profiles',
  AdminPanelOrganizationCreationRequests: 'admin-panel/organization-creation-requests',
  AdminPanelOrganizationInvestorInvitations: 'admin-panel/organization-investor-invitations',
  AdminPanelOrganizationInvestorMappings: 'admin-panel/organization-investor-mappings',
  AdminPanelOrganizations: 'admin-panel/organizations',
  Attachments: 'attachments',
  Comments: 'comments',
  Computed: 'computed',
  Crsf: 'auth/csrf',
  Currencies: 'finance-proxy/currencies',
  DataAnalytics: 'data-analytics',
  Details: 'details',
  DocumentTypes: 'document-types',
  Documents: 'documents',
  Download: 'download',
  Employees: 'hr-proxy/employees',
  Entries: 'entries',
  FinanceAccountBalance: 'finance-proxy/balance',
  FinanceAccounts: 'finance-proxy/accounts',
  FinanceAdminExternalUsers: 'finance-proxy/admin/external/users',
  FinanceAdminUsers: 'finance-proxy/admin/users',
  FinanceCardProducts: 'finance-proxy/card-products',
  FinanceCards: 'finance-proxy/cards',
  FinanceConfig: 'finance-proxy/config',
  FinanceJiraTickets: 'finance-proxy/jira/tickets',
  FinanceOperations: 'finance-proxy/operations',
  FinanceOperationsTransfer: 'finance-proxy/operations/transfer',
  FinanceOperationsWithdrawals: 'finance-proxy/operations/withdrawals',
  FinanceProviders: 'finance-proxy/providers',
  FinancialMetrics: 'financial-metrics',
  JiraConfig: 'legal-proxy/config',
  Kpi: 'kpi',
  Kpis: 'kpis',
  LegalJiraTickets: 'legal-proxy/jira/tickets',
  AllDocumentGroups: 'all-document-groups',
  LoadableDocumentGroups: 'loadable-document-groups',
  Logout: '/auth/logout',
  Memberships: 'memberships',
  Notifications: 'notifications',
  NotificationsUnreadCount: 'notifications/unread-count',
  OAuthLogin: 'auth/oauth/rc/login',
  OperationServicesRecruitment: 'hr-proxy/recruitment',
  OperationsServicesRequests: 'operation-services/requests',
  OperationsServicesSyncState: 'operation-services/sync-state',
  Organizations: 'auth/organizations',
  OperationsProxyRequests: 'operations-proxy/requests',
  Payrolls: 'payrolls',
  PayrollsList: 'payrolls/list',
  Performance: 'performance',
  PlanFact: 'plan-fact',
  Table: 'table',
  Uploader: 'uploader',
  UserProfile: 'auth/profile',
  Versions: 'versions',
  Years: 'years',
} as const;

export const NotificationFeatureGroup = {
  OperationServicesFinance: 'operation_services_finance',
  OperationServicesLegal: 'operation_services_legal',
} as const;

export const NotificationFeatureGroupAction = {
  JiraComment: 'jira_comment',
  JiraStatus: 'jira_status',
} as const;

export const NotificationStatus = {
  Read: 'read',
  Unread: 'unread',
} as const;

export const NotificationType = {
  Alert: 'alert',
  Info: 'info',
} as const;

export const DataAnalyticsDocName = {
  BudgetPlan: 'budget_plan',
  PnlStatement: 'pnl_statement',
  FinanceWallets: 'finance_wallets',
} as const;

export const FinanceAccountType = {
  Card: 'card',
  CryptoWallet: 'crypto-wallet',
  FiatWallet: 'fiat-wallet',
} as const;

export const FinanceProviderType = {
  ExcelImport: 'excel-import',
  IiiWallet: 'iii-wallet',
} as const;

export const FinanceProviderStatus = {
  Disabled: 'disabled',
  Enabled: 'enabled',
} as const;

export const AdminLevelRole = {
  Admin: 'admin',
  Approver: 'approver',
  Creator: 'creator',
  Reader: 'reader',
} as const;

export const OrganizationMembershipRole = {
  FinanceManager: 'finance-manager',
  Investor: 'investor',
  Manager: 'manager',
  Member: 'member',
  Owner: 'owner',
} as const;

export const OrganizationMembershipStatus = {
  Active: 'active',
  Disabled: 'disabled',
} as const;

export const OrganizationStatus = {
  Active: 'active',
  Deleted: 'deleted',
  Suspended: 'suspended',
} as const;

export const OrganizationRequestStatus = {
  Approved: 'approved',
  Pending: 'pending',
  Rejected: 'rejected',
} as const;

export const PortalRoleKey = {
  Employee: 'employee',
  FinanceAdmin: 'finance-admin',
  Investor: 'investor',
  Manager: 'manager',
  Owner: 'owner',
} as const;

export const JiraIssueType = {
  Invest: 'Invest BuSaaS',
  PaymentRequest: 'Payment Request BuSaaS',
} as const;

export const OperationServicesRecruitmentStatus = {
  Canceled: 'canceled',
  Done: 'done',
  InProgress: 'in_progress',
  New: 'new',
} as const;

export const OperationServicesRequestStatus = {
  Confirm: 'confirm',
  InReview: 'in_review',
  NeedMoreInfo: 'need_more_info',
  NotStarted: 'not_started',
  OnHold: 'on_hold',
  Paid: 'paid',
  Rejected: 'rejected',
  Review: 'review',
  ...OperationServicesRecruitmentStatus,
} as const;

export const JiraProject = {
  Legal: 'LEG',
  Finance: 'PAYM',
} as const;

export const Priority = {
  Blocker: 'Blocker',
  Critical: 'Critical',
  Executive: 'Executive',
  High: 'High',
  Highest: 'Highest',
  Low: 'Low',
  Lowest: 'Lowest',
  Medium: 'Medium',
  Minor: 'Minor',
  None: 'None',
  Urgent: 'Urgent',
} as const;

export const JiraPriority = {
  Blocker: Priority.Blocker,
  Executive: Priority.Executive,
  High: Priority.High,
  Highest: Priority.Highest,
  Low: Priority.Low,
  Lowest: Priority.Lowest,
  Medium: Priority.Medium,
  Minor: Priority.Minor,
  None: Priority.None,
  Urgent: Priority.Urgent,
} as const satisfies Partial<typeof Priority>;

export const OperationServicesRequestServiceType = {
  Recruitment: 'Recruitment',
  Legal: 'Legal',
  Finance: 'Finance',
  IT: 'IT',
  Administrative: 'Administrative',
  Marketing: 'Marketing',
} as const;

export const OperationRequestPriority = {
  Low: Priority.Low,
  Medium: Priority.Medium,
  High: Priority.High,
  Critical: Priority.Critical,
} as const satisfies Partial<typeof Priority>;

export const EmployeeSource = {
  Existing: 'existing',
  Recruitment: 'recruitment',
  Manual: 'manual',
} as const;

export const EmployeeStatus = {
  Active: 'active',
  Offboarded: 'offboarded',
} as const;

export const EmployeeContractType = {
  Fulltime: 'fulltime',
  Contractor: 'contractor',
  B2b: 'b2b',
} as const;

export const PayrollPaymentType = {
  Bonus: 'bonus',
  Contractor: 'contractor',
  Other: 'other',
  Salary: 'salary',
} as const;

export const PayrollStatus = {
  Canceled: 'canceled',
  Draft: 'draft',
  Executed: 'executed',
  Failed: 'failed',
  Generating: 'generating',
  PartiallyExecuted: 'partially_executed',
  Validated: 'validated',
  Validating: 'validating',
} as const;

export const FinanceOperationType = {
  BalanceAdjustment: 'Balance Adjustment',
  CardOperation: 'Card Operation',
  Deposit: 'Deposit',
  Exchange: 'Exchange',
  MassPayout: 'MassPayout',
  Refund: 'Refund',
  Transfer: 'Transfer',
  Withdrawal: 'Withdrawal',
} as const;

export const TransactionStatus = {
  All: 'all',
  Cancelled: 'cancelled',
  Completed: 'completed',
  Created: 'created',
  Declined: 'declined',
  Expired: 'expired',
  Failed: 'failed',
  InProgress: 'in_progress',
  Refunded: 'refunded',
  Rejected: 'rejected',
  Reversed: 'reversed',
  Successful: 'successful',
  Temporary: 'temporary',
} as const;

export const OrganizationHistoryAction = {
  Approved: 'approved',
  FinanceManagerAssigned: 'finance_manager_assigned',
  FinanceWalletsUploaded: 'finance_wallets_uploaded',
  GoalSet: 'goal_set',
  InvestorAssigned: 'investor_assigned',
  ManagerAssigned: 'manager_assigned',
  MemberAssigned: 'member_assigned',
  PnlStatementUploaded: 'pnl_statement_uploaded',
} as const;
